import { api } from '@/api/client'

/**
 * The background set-up after onboarding (`GET/POST /job-portals/setup`) and
 * the two typed answers a portal's page may wait for: the code it texted to
 * the person, and the phone number to text it to. Kept here until
 * `api/endpoints.ts` (another owner's file) lists them.
 */
export type SetupStage = 'creating_account' | 'needs_you' | 'finding_jobs' | 'ready' | 'stopped'

export interface SetupPortal {
  key: string
  name: string
  needsAccount: boolean
  stage: SetupStage
  message: string | null
  jobCount: number
  accountIdentifier: string | null
  waiting: { reason: string; waitedSeconds: number | null; timeoutSeconds: number | null } | null
  handoffUrl: string | null
}

export interface SetupStatus {
  startedAt: string | null
  estimatedMinutes: number
  finished: boolean
  portals: SetupPortal[]
  needsPassword: boolean
  /** Why the career pages could not be matched yet (no role and no skill on the profile). */
  careerPagesNote: string | null
  matches: { careerPages: number; portals: number; naukri: number; total: number }
  applications: { possible: number; planRemaining: number | null }
}

const portalPath = (key: string) => `/job-portals/${encodeURIComponent(key)}`

export const setupApi = {
  status: () => api.get<SetupStatus>('/job-portals/setup'),
  start: () => api.post<SetupStatus>('/job-portals/setup'),
  enterCode: (key: string, code: string) => api.post<{ message: string }>(`${portalPath(key)}/handoff/code`, { code }),
  enterPhone: (key: string, phone: string) => api.post<{ message: string }>(`${portalPath(key)}/handoff/phone`, { phone }),
}
